import ApuracaoController, { Operacao } from '@/assets/ts/controller/ApuracaoController';
import { Vue, Component, Watch, Prop, Emit } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({
  name: 'AlertasApuracao',
})
class AlertasApuracao extends Vue {
  @Prop({ required: true})
  private readonly value : boolean;

  @Getter('popUpSize')
  private popUpSize: any;
  
  private internalValue = false;
  private alerts = [];
  private title: string = null;

  @Watch('value', { immediate: true })
  private async valueOnChange() {
    this.internalValue = this.value;
    if (!this.value) {
      return;
    }

    this.setTitle();
    const operacaoAlerts = ApuracaoController.getWarningsLastOperacao();
    this.alerts = operacaoAlerts.map((item) => {
      return {
        title: item.nome,
        desc: item.message.substring(0, 200),
        type: item.type,
      };
    });
  }

  @Emit('input')
  private emitInput(value: boolean) {
    return value;
  }

  private closeDialog() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
  }

  private closeButtonOnClick() {
    this.closeDialog();
  }

  private setTitle() {
    const lastApuracaoDescriptions = ApuracaoController.getLastOperacao();
    switch (lastApuracaoDescriptions) {
      case Operacao.Apuracao:
        this.title = 'Alertas Apuração';
        break;
      case Operacao.Retrocesso:
        this.title = 'Alertas Retrocesso';
        break;
      default:
        this.title = 'Alertas Apuração';
    }
  }
}

export default AlertasApuracao;
